import { fromPromise } from 'xstate';

import { apolloClient } from '@/lib/apollo';
import {
  ChooseStopSelectionMutation,
  RefreshScheduledBusesQuery,
  ViewNextScheduledBusesQuery,
} from '@/lib/gql/__generated__/canonical-documents';
import type {
  ChooseStopSelectionInput,
  ChooseStopSelectionMutationMutation,
  RefreshScheduledBusesQueryQuery,
  ViewNextScheduledBusesQueryQuery,
} from '@/lib/gql/__generated__/graphql';

export const viewNextScheduledBusesActor = fromPromise<
  ViewNextScheduledBusesQueryQuery['viewNextScheduledBuses'],
  void
>(() =>
  apolloClient
    .query({
      query: ViewNextScheduledBusesQuery,
      variables: {},
      fetchPolicy: 'network-only',
    })
    .then(({ data }) => {
      if (!data) {
        throw new Error('We could not load the next buses.');
      }
      return data.viewNextScheduledBuses;
    }),
);

export const refreshScheduledBusesActor = fromPromise<RefreshScheduledBusesQueryQuery['refreshScheduledBuses'], void>(
  () =>
    apolloClient
      .query({
        query: RefreshScheduledBusesQuery,
        variables: {},
        fetchPolicy: 'network-only',
      })
      .then(({ data }) => {
        if (!data) {
          throw new Error('We could not refresh the next buses.');
        }
        return data.refreshScheduledBuses;
      }),
);

export const chooseStopSelectionActor = fromPromise<
  ChooseStopSelectionMutationMutation['chooseStopSelection'],
  ChooseStopSelectionInput
>(({ input }) =>
  apolloClient
    .mutate({
      mutation: ChooseStopSelectionMutation,
      variables: {
        input: {
          selectionId: input.selectionId,
          route: input.route,
          direction: input.direction,
          stopId: input.stopId,
          stopName: input.stopName,
        },
      },
    })
    .then(({ data }) => {
      if (!data) {
        throw new Error('We could not save your stop choice.');
      }

      if (!data.chooseStopSelection.success) {
        throw new Error(data.chooseStopSelection.error?.message ?? 'We could not save your stop choice.');
      }

      return data.chooseStopSelection;
    }),
);
